import { useEffect, useState } from "react";
import { useLang } from "../lib/useLang";
import { PROMO } from "../data/promo";
import { SmartImage } from "./SmartImage";

const SEEN_KEY = "kb_promo_seen";

/** Homepage welcome/deal popup — appears once per session, ~1s after load. */
export function DealPopup() {
  const { pick } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!PROMO.enabled || sessionStorage.getItem(SEEN_KEY)) return;
    const timer = setTimeout(() => {
      setOpen(true);
      sessionStorage.setItem(SEEN_KEY, "1");
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (!open) return null;

  function goToMenu() {
    setOpen(false);
    setTimeout(
      () => document.getElementById("sec-daily")?.scrollIntoView({ behavior: "smooth" }),
      60,
    );
  }

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      onClick={() => setOpen(false)}
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 bg-black/55" />
      <div
        className="fade-up relative w-full max-w-sm overflow-hidden rounded-3xl bg-white shadow-raised"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="img-skeleton relative h-40">
          <SmartImage
            src={PROMO.image}
            alt=""
            eager
            className="h-full w-full object-cover"
            fallback={
              <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-brand to-brand-dark text-6xl">
                {PROMO.emoji}
              </div>
            }
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 to-transparent" />
          <button
            onClick={() => setOpen(false)}
            aria-label="close"
            className="absolute end-3 top-3 grid size-9 place-items-center rounded-full bg-white/90 text-lg shadow-soft"
          >
            ✕
          </button>
        </div>
        <div className="p-5 text-center">
          <div className="text-3xl">{PROMO.emoji}</div>
          <h3 className="display mt-1 text-xl text-ink">
            {pick(PROMO.headlineEn, PROMO.headlineAr)}
          </h3>
          <p className="mt-2 text-sm text-black/60">{pick(PROMO.bodyEn, PROMO.bodyAr)}</p>
          <button className="btn-primary mt-4 w-full" onClick={goToMenu}>
            {pick(PROMO.ctaEn, PROMO.ctaAr)}
          </button>
        </div>
      </div>
    </div>
  );
}
